import SpinRecord from "slotworks/model/gameplay/records/spin-record";

export default class FreespinRecord extends SpinRecord {

    /** ID for debugging purposes */
    public id: string = "FreespinRecord";

    public gameName: string = "";
}
